// DocumentSearchScope — the nest-scope chip (CTSK-493 §5.5; design doc
// §3.5). Rendered above the first result when the Documents page has a
// nest quick-filter active: `In nest: BI × [search all nests]`. Clearing
// lifts the filter for the current search only — the page's own ?nest=
// filter is untouched (brief: no nest-filter chip UI changes).

export interface DocumentSearchScopeProps {
  /** Compact code for the chip ("BI"); falls back to the slug. */
  code: string;
  /** Human name for the title / screen readers. */
  name: string;
  onClear: () => void;
}

export function DocumentSearchScope({ code, name, onClear }: DocumentSearchScopeProps) {
  return (
    <div className="doc-search__scope" data-testid="document-search-scope">
      <span>In nest:</span>
      <span className="doc-search__badge" title={name}>{code}</span>
      <button
        type="button"
        className="doc-search__scope-clear"
        onMouseDown={(e) => e.preventDefault()}
        onClick={onClear}
        aria-label={`Clear nest filter ${name} and search all nests`}
      >
        <span aria-hidden="true">×</span> search all nests
      </button>
    </div>
  );
}
